import type { IDataOption } from 'xsolis-component-library';

import {
  REVIEW_TYPE_SYSTEM_NAMES_PA_POP,
  REVIEW_TYPE_SYSTEM_NAMES_PAYER_POP,
  REVIEW_TYPE_SYSTEM_NAMES_UR_POP,
} from '@/libs/Constants';

import type { PatientReview } from './types';

export const MILLISECONDS_IN_SECOND = 1000;
export const SECONDS_IN_HOUR = 3600;
export const MINUTES_IN_HOUR = 60;
export const SECONDS_IN_MINUTE = 60;

export const OBSERVATION = 'Observation';
export const OBSERVATION_PLUS = 'ObservationPlus';
export const INPATIENT = 'Inpatient';
export const INPATIENT_PLUS = 'InpatientPlus';
export const PEER_TO_PEER_PA = 'Peer-to-Peer PA';
export const PEER_TO_PEER = 'Peer-to-Peer';

export const UNASSIGN = 'Unassign';
export const UNASSIGNED = 'Unassigned';
export const ASSIGN_TO = 'Assign To';
export const REMOVE_PATIENT_ENCOUNTER = 'Remove Patient Encounter';
export const ASSIGN_TO_ME = 'ASSIGN TO ME';
export const VIEW_PATIENT_DETAILS = 'VIEW PATIENT DETAILS';
export const ACCOUNT_NO = 'Account #';
export const GO_TO_MESSAGE_FEED = 'Go to Message Feed';
export const GO_TO_REVIEWS = 'Go to Reviews';
export const LATEST_COMMENT = 'Latest Comment';
export const DEFAULT_COMMENT = 'No Summary Documented';
export const LATEST_REVIEW_SUMMARY = 'Latest Review Summary';
export const LATEST_PA_REVIEW_SUMMARY = 'Latest PA Review Summary';
export const LATEST_PAYER_REVIEW_SUMMARY = 'Latest Payer Review Summary';
export const LATEST_UR_REVIEW_SUMMARY = 'Latest UR Review Summary';

export const GRID_SETTINGS_SAVE_DELAY = 500;

export const COLUMN_ORDER = 'columnOrder';
export const COLUMN_SIZING = 'columnSizing';
export const COLUMN_SORT = 'sort';
export const COLUMN_FILTER = 'filter';
export const COLUMN_PINNING = 'columnPinning';
export const COLUMN_VISIBILITY = 'columnVisibility';
export const GRID_INITIALIZING = 'gridInitializing';

export const COLUMN_STATES_FOR_LOCAL_SAVING = new Set([
  COLUMN_SORT,
  COLUMN_FILTER,
]);

export const COLUMN_STATES_FOR_BE_SAVING = new Set([
  COLUMN_ORDER,
  COLUMN_SIZING,
  COLUMN_PINNING,
  COLUMN_VISIBILITY,
]);

export enum PediatricIndicatorValues {
  OVER_18 = 'Over 18',
  UNDER_18 = 'Under 18',
}

export enum ArrowDirection {
  LEFT = 'left',
  RIGHT = 'right',
}

export const UNASSIGNED_OPTION: IDataOption = {
  id: UNASSIGNED,
  name: UNASSIGNED,
};

export const ASSIGN_TO_ME_OPTION: IDataOption = {
  id: ASSIGN_TO_ME,
  name: ASSIGN_TO_ME,
};

export const REMOVE_PATIENT_ENCOUNTER_OPTION: IDataOption = {
  id: REMOVE_PATIENT_ENCOUNTER,
  name: REMOVE_PATIENT_ENCOUNTER,
};

export enum REVIEW_STATUS {
  COMPLETED = 'Completed',
  IN_PROGRESS = 'In Progress',
  PENDING = 'Pending',
}

export enum REVIEW_TYPE {
  PA = 'PA',
  PAYER = 'PAYER',
  UR = 'UR',
}

export const SYSTEM_NAME_KEY: keyof PatientReview = 'review_type_system_name';

export const reviewTypeMap = {
  [REVIEW_TYPE.PA]: REVIEW_TYPE_SYSTEM_NAMES_PA_POP,
  [REVIEW_TYPE.PAYER]: REVIEW_TYPE_SYSTEM_NAMES_PAYER_POP,
  [REVIEW_TYPE.UR]: REVIEW_TYPE_SYSTEM_NAMES_UR_POP,
};

export const BLANK = 'Blank';
